import React from "react";
import Icon from "../../lib/icon";

export default function BadgeTime({
  size = "regular",
  label = "15-20 мин",
  icon = "moped-filled",
}) {
  const containerClasses = (() => {
    const base = "flex items-center rounded-2xl bg-[#BBA3A8]/20";

    if (size === "small") return `${base} px-1 py-[2px] gap-1 h-4 w-max`;
    return `${base} px-2 py-1 gap-1 h-6 w-max`;
  })();

  const iconSize = size === "small" ? 12 : 16;

  const textClasses =
    size === "small"
      ? "text-[9px] leading-[12px] font-inter-18-semi-bold tracking-[0.016em]"
      : "text-[12px] leading-[16px] font-inter-18-semi-bold";

  return (
    <div className={containerClasses}>
      <div style={{ width: iconSize, height: iconSize }}>
        <Icon name={icon} width={iconSize} height={iconSize} color="#81545D" />
      </div>

      <span className={textClasses} style={{ color: "#81545D" }}>
        {label}
      </span>
    </div>
  );
}
